<template>
  <div class="qiye-detail">
    <!--头部-->
    <div class="header-wrapper">
      <div class="left" @click="goback">
        <div class="iconfont icon-fanhui2" style="font-size:35px"></div>
      </div>
      <div class="header">{{ qiye.name }}</div>
      <div class="jifen-change box" v-show="tabIndex === 0">
        <Button class="bkcc-btn" @click="downloadRecordCard">下载登记码</Button>
        <Button
          class="bkcc-btn editBtn"
          v-if="!isBianji"
          @click="changeBtn"
          :loading="bianjiLoading"
        >编辑</Button>
        <Button
          class="bkcc-btn editBtn"
          v-if="isBianji"
          @click="changeBtn"
          :loading="bianjiLoading"
        >保存</Button>
        <Button class="bkcc-btn" v-if="shStatus == 1" @click="statusModal">审核不通过</Button>
        <Button class="bkcc-btn" v-if="shStatus == 2" @click="statusModal">审核不通过</Button>
        <Button class="bkcc-btn" v-if="shStatus != 1" @click="shenhe">审核通过</Button>
      </div>
    </div>

    <Tabs type="card" :animated="false" class="tabs-wrap" @on-click="onTabChange">
      <TabPane label="企业信息">
        <!--加盟详情编辑页面-->
        <qiye-bianji
          ref="bianji"
          v-if="isBianji"
          class="bianjiCard"
          :bianjiLoading="bianjiLoading"
          :companyId="companyId"
          :childShequ="childShequ"
          :oldQiye="qiye"
          @successBianji="successBianji"
          @closeLoading="closeLoading"
          :community-id="communityId"
        ></qiye-bianji>
        <qiye-xiangqing v-else class="bianjiCard" :qiye="qiye"></qiye-xiangqing>
        <Card class="msg_card" v-if="status == 0">
          <div class="msg_title">审核不通过原因及意见</div>
          <div class="msg_con">{{ msg }}</div>
        </Card>
        <qiye-pingjia class="pingjiaCard" :scoreInfo="scoreInfo" :companyId="companyId"></qiye-pingjia>
        <Modal v-model="noPass" title="审核不通过" @on-ok="shenheFail">
          <p>不通过理由及意见</p>
          <Input v-model="passSug" :maxlength="1024" type="textarea" style="width: 490px" />
        </Modal>
      </TabPane>

      <!-- 防疫信息 -->
      <TabPane label="防疫信息">
        <qy-epidemic></qy-epidemic>
      </TabPane>

      <!-- 员工管理 -->
      <TabPane label="员工管理">
        <qy-employee></qy-employee>
      </TabPane>
       <!-- 员工管理 -->
      <TabPane label="员工进出记录">
        <access-record></access-record>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import qiyeXiangqing from "./components/qiyeXiangqing";
import qiyeBianji from "./components/qiyeBianji";
import qiyePingjia from "./components/qiyePingjia.vue";
import qyEmployee from "./components/qyEmployee.vue";
import qyEpidemic from "./components/qyEpidemic.vue";
import accessRecord from "./components/accessRecord.vue";
var that;
export default {
  components: {
    qiyeXiangqing,
    qiyeBianji,
    qiyePingjia,
    qyEmployee,
    qyEpidemic,
    accessRecord
  },
  data() {
    return {
      tabIndex: 0,
      communityId: "",
      isBianji: false, //是否在编辑
      bianjiLoading: false, //按钮的loading状态
      companyId: "",
      qiye: {
        headPic: [
          {
            path: "",
            id: ""
          }
        ],
        name: "",
        location: "",
        zuobiao: {
          value: "",
          label: ""
        },
        jianjie: "",
        qyType: [], //企业类型
        qyNature: [], //企业属性
        serviceType: [],
        zhuceNum: "",

        farenName: "",
        farenTel: "",
        zerenName: "",
        zerenTel: "",
        timeList: [],
        startTime: "",
        endTime: "",
        area: "",
        xingzhi: "",
        community: "",
        imgArr: [],
        businessScope: "",
        employeeNum: "",
        licensePicArr: "",
        allKindPicArr: "",
        promisePicArr: "",
        healthyPicArr: "",
        alias: "",
        paisong: "",
        paisongTime: [],
        companyType: ""
      },
      childShequ: [],
      scoreInfo: {
        score: "",
        people: ""
      },
      shStatus: "",
      status: -1,
      passSug: "",
      noPass: false,
      msg: ""
    };
  },
  methods: {
    // 切换
    onTabChange(e) {
      this.tabIndex = e;
    },
    getScore() {
      var url = this.urlobj.getQyScore(this.companyId);
      this.$get(url).then(res => {
        this.scoreInfo = {
          score: parseFloat((res.newPrimaryKeys.avgScore / 100).toFixed(1)),
          people: res.newPrimaryKeys.totalUserNum
        };
      });
    },
    getDetail() {
      var url = this.urlobj.getQyDetail(this.companyId);
      this.$get(url).then(res => {
        this.communityId = res.rows[0].communityId.toString();
        that.initData(res.rows[0]);
        let info = res.rows[0].checkInfo;
        that.status = info.status;
        that.msg = info.checkMsg;
      });
    },
    initData(data) {
      var qy = this.qiye;
      qy.tradeName = data.tradeName;
      qy.deptName = data.deptName;
      qy.deptId = data.deptId;
      qy.tradeId = data.tradeId;
      qy.qyType = data.companyTypeList.map(item => {
        return {
          name: item.propertyName,
          id: item.propertyId
        };
      });
      qy.paisong = data.canDelivery ? "是" : "否";
      qy.paisongTime = data.deliveryTimeList.map(item => {
        return {
          beginTime: item.beginTime,
          endTime: item.endTime
        };
      });
      qy.companyType = data.companyType == 1 ? "个体" : "企业";
      qy.name = data.companyName;
      qy.alias = data.companyAlias;
      qy.headPic[0] = {
        path: data.headPicUrl
      };
      qy.zhuceNum = data.registrationNO ? data.registrationNO : "无";
      qy.serviceType = data.companyServiceList.map(item => {
        return {
          name: item.propertyName,
          id: item.propertyId
        };
      });
      if (data.address) {
        var reg = /[0-9]+.[0-9]+/g;
        var xy = data.coordinate ? data.coordinate.match(reg) : [];
        xy = typeof xy == "object" && xy != null ? xy.join(",") : xy;
        qy.zuobiao = {
          label: data.address,
          value: xy
        };
      }
      qy.farenName = data.legal;
      qy.farenTel = data.legalPhoneNO;
      qy.zerenName = data.manager;
      qy.zerenTel = data.managerPhoneNO;
      qy.area = data.acreage;
      qy.businessScope = data.businessScope;
      qy.employeeNum = data.employeeNum;
      if (data.licensePicUrl && data.licensePicUrl.indexOf(",") != -1) {
        qy.licensePicArr = data.licensePicUrl.split(",");
      } else {
        qy.licensePicArr =
          data.licensePicUrl && data.licensePicUrl.length > 1
            ? data.licensePicUrl.split()
            : data.licensePicUrl;
      }
      if (data.companyProveUrl && data.companyProveUrl.indexOf(",") != -1) {
        qy.allKindPicArr = data.companyProveUrl.split(",");
      } else {
        qy.allKindPicArr =
          data.companyProveUrl && data.companyProveUrl.length > 1
            ? data.companyProveUrl.split()
            : data.companyProveUrl;
      }
      if (data.promisePicUrl && data.promisePicUrl.indexOf(",") != -1) {
        qy.promisePicArr = data.promisePicUrl.split(",");
      } else {
        qy.promisePicArr =
          data.promisePicUrl && data.promisePicUrl.length > 1
            ? data.promisePicUrl.split()
            : data.promisePicUrl;
      }

      if (data.healthyPicUrl && data.healthyPicUrl.indexOf(",") != -1) {
        qy.healthyPicArr = data.healthyPicUrl.split(",");
      } else {
        qy.healthyPicArr =
          data.healthyPicUrl && data.healthyPicUrl.length > 1
            ? data.healthyPicUrl.split()
            : data.healthyPicUrl;
      }

      qy.timeList = data.timeList.map(item => {
        return {
          beginTime: item.beginTime,
          endTime: item.endTime
        };
      });
      qy.xingzhi = {
        id: data.featureId,
        name: data.featureName
      };
      qy.qyNature = data.companyAttrList.map(item => {
        return {
          id: item.propertyId,
          name: item.propertyName
        };
      });
      qy.jianjie = data.remark;
      qy.imgArr = data.attachmentList.map(item => {
        return {
          id: item.fileId,
          path: item.filePath
        };
      });
      qy.community = {
        id: data.communityId,
        name: data.communityName
      };
      this.qiye = qy;
      console.log(this.qiye);
    },
    goback() {
      // this.$router.push({ name: "userEnterprise"});
      if (this.isBianji) {
        this.isBianji = false;
      } else {
        this.$router.go(-1);
      }
    },
    // 下载登记码
    downloadRecordCard() {
      let url = `${this.urlobj.walkRecordDownload}?token=${this.$store.state.access_token}&comeType=3&comeIdList=${this.companyId}`;
      window.open(url);
    },
    async changeBtn() {

      if (!this.isBianji) {
        this.isBianji = true;
      } else {
        this.bianjiLoading = true;
        
      }
    },
    initIcon(value) {
      switch (value) {
        case "breakfast":
          return {
            icon: "icon-zaocan",
            color: "#ff8e2e"
          };
        case "farmer":
          return {
            icon: "icon-caishichang",
            color: "#9bcf50"
          };
        case "haircut":
          return {
            icon: "icon-lifadian",
            color: "#43bdf0"
          };
        case "pharmacy":
          return {
            icon: "icon-yiliao",
            color: "#45ae76"
          };
        case "park":
          return {
            icon: "icon-tingchechang",
            color: "#fcba28"
          };
        case "maintenance":
          return {
            icon: "icon-xiuchedian",
            color: "#0ca3d2"
          };
        case "hardware":
          return {
            icon: "icon-wujindian",
            color: "#5d82d2"
          };
        case "market":
          return {
            icon: "icon-chaoshi1",
            color: "#f44321"
          };
        default:
          return "";
      }
    },
    getChildShequ() {
      var url = this.urlobj.getChildShequ;
      this.$get(url).then(res => {
        that.childShequ = res.rows.map(item => {
          return {
            name: item.communityName,
            id: item.communityId
          };
        });
      });
    },
    successBianji(status) {
      this.isBianji = false;
      this.bianjiLoading = false;
      this.shStatus = status;
      this.getDetail();
    },
    closeLoading() {
      this.bianjiLoading = false;
    },
    statusModal() {
      this.noPass = true;
    },
    qyShenhe(status, checkMsg) {
      var data = {
        companyId: this.companyId,
        status,
        checkMsg
      };
      var url = this.urlobj.checkCompany;
      this.$post(url, data)
        .then(res => {
          this.$Message.success("操作成功");
          this.$router.go(-1);
        })
        .catch(e => {
          this.$Message.warning("操作失败");
        });
    },
    shenhe() {
      this.qyShenhe(1, "");
    },
    shenheFail() {
      //审核不通过意见为必填
      if (this.passSug == "") {
        this.$Message.warning("请填写审核不通过原因及意见");
        return;
      }
      this.qyShenhe(0, this.passSug);
    },
    getCity(id) {
      this.$get(this.urlobj.getCity + "id=" + id)
        .then(res => {
          let cityid = res.rows[0].path.split(".")[2];
          this.getCityName(cityid);
        })
        .catch(e => {});
    },
    getCityName(id) {
      this.$get(this.urlobj.getCity + "id=" + id)
        .then(res => {
          this.cityremark = res.rows[0].remark || "";
          this.isWuhan =
            res.rows[0].pathname.indexOf("武汉") > -1 ? true : false;
          sessionStorage.setItem("isWuhan", this.isWuhan);
          sessionStorage.setItem("cityremark", this.cityremark);
          this.initTableTitle();
        })
        .catch(e => {});
    }
  },
  mounted() {
    //获取城市简称（防疫表单用）
    this.getCity(this.$store.state.streetorcommunityid);
    ///////////////
    that = this;
    this.companyId = this.$route.query.companyId;
    this.shStatus = this.$route.query.status;
    this.getScore();
    this.getDetail();
    if (this.$store.state.isJiedao) {
      this.getChildShequ();
    }
  }
};
</script>

<style scoped>
.qiye-detail {
  padding-bottom: 30px;
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.tabs-wrap >>> .ivu-tabs-bar {
  width: 97%;
  margin: 0 auto;
  margin-bottom: 0;
}
.jifen-change {
  position: absolute;
  right: 20px;
  top: 25px;
}
/* 返回 */
.left {
  position: absolute;
  left: 20px;
  font-size: 22px;
}
.header {
  font-size: 25px;
  text-align: center;
}
.bianjiCard {
  margin: 0 auto;
  position: relative;
}
.editBtn {
  position: absolute;
  right: 20px;
  bottom: -120px;
  z-index: 1;
}
.pingjiaCard {
  margin: 20px auto 0;
}
.sh_btn {
  border: 1px solid #dedede;
  background: #fff;
  color: #333;
}
.msg_title {
  font-size: 20px;
  font-weight: bolder;
  color: #333;
}
.msg_con {
  width: 750px;
  margin: 40px auto;
  color: #999;
}
.msg_card {
  margin: 20px 26px 0;
}
</style>
